import React from "react"
import { useTranslation } from "react-i18next";
import { Message } from "semantic-ui-react"


interface ErrorListProps {
    errors: Array<any>
};

export const ErrorList: React.FC<ErrorListProps> = ({ errors }) => {
    const t = useTranslation().t
    const errorMessage = t("Lomakkeella on virheitä!");
    return (
        <Message className="sui-error-list" negative>
            <Message.Header>{errorMessage}</Message.Header>
            {/*
            <Message.List>
                {errors.map((error, index) => (
                    <Message.Item key={`error-${index}`}>{error.stack}</Message.Item>
                ))}
            </Message.List>
             */}
        </Message>
    );
};

export default ErrorList;